module.exports = ".user-feedback{margin-top:25px}.user-feedback .icon{font-size:62px}.user-feedback .message{font-size:18px}.user-feedback.info{color:#FFC107}.user-feedback.warning{color:#FF5722}.user-feedback.success{color:#4CAF50}.user-feedback.error{color:#E41736}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/ui/user-feedback/user-feedback.component.scss
// module id = 620
// module chunks = 0